export default {
    comparison: {
        title: 'How do we compare? | Comparison Chart',
        description: 'See how NobleWills compares with the competition in terms of price, accuracy, process, and more.',
        keywords: 'law firms, will writers, will template',
        heading: 'How do we ',
        heading2: 'compare?',
    },
};
